import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VModal from 'vue-js-modal';

// https://github.com/FortAwesome/vue-fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// global filter
import priceFormat from '@/filter/priceFormat';
import unitPriceFormat from '@/filter/unitPriceFormat';
import dateFormat from '@/filter/dateFormat';
import shortDateFormat from '@/filter/shortDateFormat';
import numberFormat from '@/filter/numberFormat';

Vue.config.productionTip = false;

Vue.use(VModal);

library.add(faCalendar);
Vue.component('v-icon', FontAwesomeIcon);

Vue.filter('priceFormat', priceFormat);
Vue.filter('unitPriceFormat', unitPriceFormat);
Vue.filter('dateFormat', dateFormat);
Vue.filter('shortDateFormat', shortDateFormat);
Vue.filter('numberFormat', numberFormat);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
